import React, { HTMLAttributes } from 'react'
import classNames from 'classnames'
import { Dropdown } from '@scentregroup/ui'
import map from 'lodash/map'
import { rangesForDate } from '../../helpers/time-ranges'
import { MDate, TimeRange } from '../../../types/whats-on'
import trackEvent from '../../helpers/analytics-utils/track-event'
import {
  categories,
  actions,
  labels,
} from '../../helpers/analytics-utils/constants'
import style from './index.module.scss'

const ALL_DATES = { value: 'any', label: 'Any date' }

interface DateRangeOptions {
  value: string
  label: string
}

export interface DateRangeFilterProps {
  selectedDateRange?: string
  onChange: (selectDateRange: string) => void
  baseDate: MDate
  className?: HTMLAttributes<typeof CSS>
  id?: string
  dataTestId?: string
}

const DateRangeFilter = ({
  selectedDateRange,
  onChange,
  baseDate,
  className,
  id,
  dataTestId,
}: DateRangeFilterProps): JSX.Element => {
  const ranges: TimeRange[] = rangesForDate(baseDate, selectedDateRange)
  const options: DateRangeOptions[] = map(ranges, (item: TimeRange) => ({
    value: item.slug(),
    label: item.name,
  }))

  const onDateRangeChange = (e: React.FormEvent<HTMLSelectElement>): void => {
    trackEvent(
      categories.WHATS_HAPPENING_FILTERS,
      actions.DATE_RANGE_SELECT,
      e.currentTarget.value === 'any' ? 'any-date' : e.currentTarget.value
    )
    if (e.currentTarget.value === ALL_DATES.value) {
      onChange('')
    } else {
      onChange(e.currentTarget.value)
    }
  }

  const onDateDropdown = (): void => {
    trackEvent(
      categories.WHATS_HAPPENING_FILTERS,
      actions.DATE_RANGE_EXPAND,
      labels.EXPAND
    )
  }

  options.unshift(ALL_DATES)
  return (
    <Dropdown
      classNames={{
        wrapper: classNames(className, style.wrapper),
        field: classNames(style.field, style.fieldOverride),
      }}
      options={options}
      value={selectedDateRange}
      id={id}
      dataTestId={dataTestId}
      onChange={onDateRangeChange}
      onClick={onDateDropdown}
    />
  )
}

DateRangeFilter.defaultProps = {
  classNames: { wrapper: '' },
  selectedDateRange: ALL_DATES.value,
}
export default DateRangeFilter
